//@flow
import * as React from 'react';
import { FormGroup } from 'reactstrap';
import FormSelectInput from '../../components/Inputs/FormSelectInput';
import { isSudo } from '../../helpers/permissions.helper';
import { clienteService } from '../../services/cliente.service';
import { produtoService } from '../../services/produto.service';
import { userService } from '../../services/user.service';

type Props = { onChangeText: any, entity: any, onChangeValue: any };

export default class ProdutoBloqueadoCrudListFilter extends React.PureComponent<Props> {
  render() {
    const { entity } = this.props;
    const user = userService.getCurrentUser();

    return (
      <React.Fragment>
        {isSudo() && (
          <FormGroup className="col-12 col-xl-3">
            <FormSelectInput
              name="cliente"
              id="cliente"
              label="Cliente"
              placeholder="Selecione o cliente"
              valueKey="codigoCliente"
              labelKey="label"
              required={true}
              returnFullObject={true}
              service={clienteService.findAll}
              onChange={(name, value) => {
                this.props.onChangeDate(name, value);
                // this.props.onChangeDate('produto', null);
              }}
              value={entity.cliente}
            />
          </FormGroup>
        )}

        <FormGroup className="col-12 col-xl-4">
          <FormSelectInput
            key={(entity.cliente && entity.cliente.codigoCliente) || 'produto'}
            name="produto"
            id="produto"
            label="Produto"
            placeholder="Selecione o produto"
            labelKey="label"
            valueKey="id"
            required={true}
            returnFullObject={true}
            parent={isSudo() ? entity.cliente : user.cliente}
            service={produtoService.findAll}
            onChange={(name, value) => {
              console.log(value);

              this.props.onChangeValue(value, name);
            }}
            value={entity.produto}
          />
        </FormGroup>
      </React.Fragment>
    );
  }
}
